module.exports = __webpack_public_path__ + "static/img/group22.cdc416c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group22.jpg
// module id = ZGjB
// module chunks = 0